import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen grain relative flex items-center justify-center bg-[var(--nl-bg)] px-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md border border-white/10 bg-[var(--nl-bg-2)] p-10 text-center"
      >
        <Link to="/" className="flex items-baseline gap-1 mb-8 justify-center">
          <span className="font-serif text-2xl">Namarck</span>
          <span className="font-serif text-2xl italic text-gold">Limo</span>
        </Link>
        <h1 className="font-serif font-light text-4xl mb-3">Checkout cancelled</h1>
        <p className="text-white/50 font-body mb-8">No hold was placed and you weren't charged. Your ride wasn't reserved — feel free to try again.</p>
        <Link to="/#book" data-testid="try-again-btn" className="inline-block label bg-gold text-black px-8 py-4 hover:bg-[var(--nl-gold-hover)] transition-colors duration-300">
          Try Again
        </Link>
      </motion.div>
    </div>
  );
}
